<template>
	<div>
		<el-form label-position="left" label-width="80px" :model="transferForm" ref="transferForm">
			<el-form-item prop="fsIp" label="转接类型：">
				<el-select v-model="transferForm.type" size="small" filterable>
					<el-option v-for="item in [{id: '0', name: '坐席'}, {id: '1', name: '外线'}]" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="phone" label="转接号码：">
				<el-input v-if="transferForm.type === '1'" v-model="transferForm.phone" size="small" placeholder="请输入"></el-input>
				<el-select v-else v-model="transferForm.phone" size="small" filterable>
					<el-option v-for="item in extensList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div style="text-align: center;margin-top: 18px;">
			<el-button @click="handleBusyOperate" :loading="loading" size="mini" type="primary">确 认</el-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	props: ['sipDriver'],
	computed: {
		...mapGetters([
			'userInfo',
			'StoreIsCallCurrentInfo'
		])
	},
	watch: {
		'transferForm.type': {
			handler(val) {
				this.transferForm.phone = (val === '1' && this.brandName == this.userInfo.brandIdentify) ? '4001007777' : '';
			},
			immediate:true,
			deep: true
		},
	},
	data() {
		return {
			transferForm: {
				type: '0',
				phone: ''
			},
			extensList: [],
			loading: false,
			brandName:process.env.VUE_APP_BRANDNAME
		}
	},
	mounted() {
		this.extensList = [];
		this.$api.apiPostProjectExtensList({
			projectCode: this.userInfo.brandIdentify,
		}).then(response => {
			if(response.errcode != 0) return;
			for(const item of response.data) {
				if(item.ext != this.userInfo.deviceCode) {
					this.extensList.push({
						id: item.ext,
						name: item.nickname
					});
				}
			}
		});
	},
	methods: {
		...mapMutations({
			'SET_SOFT_PHONE_IN_MSG': 'telService/SET_SOFT_PHONE_IN_MSG',
		}),
		handleBusyOperate() {
			if(!this.transferForm.phone){
				this.$message.error(`转接号码不能为空`);
				return;
			}
			this.$api.apiPostManageMemberThreeway({
				calledNumber: this.transferForm.phone,
				device: this.userInfo.deviceCode,
				projectCode: this.userInfo.brandIdentify,
				type: this.transferForm.type,
				uuid: this.StoreIsCallCurrentInfo.uuid
			}).then(response => {
				if(response.errcode != 0) {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: `会议调用失败`,
						data: {
							errmsg: response.errmsg
						}
					});
					this.loading = false;
					return;
				}
				this.SET_SOFT_PHONE_IN_MSG({
					msg: `会议 号码: ${this.transferForm.phone} 类型: ${this.transferForm.type}`,
				});
				this.$emit('signClose');
				this.loading = false;
				// this.sipDriver._refer(`${this.transferForm.type}${this.transferForm.phone}`);
			});
		},
	}
}
</script>